// extracted by mini-css-extract-plugin
export default {"iconAlign":"iconAlign---BC6n3"};